import React from "react";
import { getFrontmatter, getFields } from "../utils/functions";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import BoardsSpecsTable from "./BoardsSpecsTable";

const StaticComparisonTable = ({ slugs, category }) => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        edges {
          node {
            id
            ...MCUFrontmatter
            ...SBCFrontmatter

            fields {
              slug
            }
          }
        }
      }
    }
  `);

  const filter = () => {
    return data.allMarkdownRemark.edges
      .filter(({ node }) => slugs.includes(node.fields.slug))
      .map(({ node }) => {
        return {
          ...node[getFrontmatter(category)],
          id: node.id,
          path: `${category}s/${node.fields.slug}`,
        };
      });
  };

  const tableHead = boardsData => (
    <thead>
      <tr>
        <th className="border-r border-white"></th>
        {(boardsData || []).map((board, i) => (
          <th key={i} className="p-2 border-r border-white">
            <div className="flex justify-center">
              <Img
                alt={board.title}
                fluid={board.featured_image.thumbnail.childImageSharp.fluid}
                className="w-32"
              />
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );

  return (
    <BoardsSpecsTable
      fields={getFields(category)}
      boardsData={filter()}
      tableHead={tableHead}
    />
  );
};

export default StaticComparisonTable;
